import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      allowMultiLoading: false,
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
      excludeCacheFor: ["cimode"],
      // Keep language code as-is (don't normalize zh_CN to zh-CN)
      convertDetectedLanguage: (lng: string) => lng,
    },

    ns: [
      "common",
      "header",
      "sidebar",
      "home",
      "settings",
      "pipeline-studio",
      "plans",
      "table",
      "notFound",
    ],
    defaultNS: "common",
  });

export default i18n;
